import { z } from 'zod';
import { jsonObject, localeSchema, timestamp, uuid } from './common.js';
/**
 * Content / CMS (§4, §26). `blog_posts`, `landing_content`, `legal_documents`.
 * ALL stored HTML is sanitized SERVER-SIDE (isomorphic-dompurify) BEFORE
 * persist; edits insert a new monotonic `version` (never overwrite).
 */
export const contentStatus = z.enum(['draft', 'published']);
export const blogPostSchema = z.object({
    id: uuid,
    slug: z.string().min(1).max(200), // UNIQUE per locale
    locale: localeSchema,
    /** Links locale variants for hreflang (§26/E18). */
    translationGroupId: uuid,
    title: z.string().min(1).max(300),
    /** Sanitized HTML — safe to `dangerouslySetInnerHTML`. */
    bodyHtml: z.string(),
    status: contentStatus,
    seoJsonb: jsonObject.nullable(),
    publishedAt: timestamp.nullable(),
    createdAt: timestamp,
    updatedAt: timestamp,
});
export const landingContentSchema = z.object({
    id: uuid,
    blockKey: z.string().min(1).max(120),
    locale: localeSchema,
    version: z.number().int().positive(), // monotonic per (blockKey, locale)
    status: contentStatus,
    /** Structured CMS block payload (sanitized where it holds HTML). */
    contentJsonb: jsonObject,
    publishedAt: timestamp.nullable(),
    createdAt: timestamp,
});
export const legalDocType = z.enum(['terms', 'privacy', 'dmca']);
export const legalDocumentSchema = z.object({
    id: uuid,
    docType: legalDocType,
    locale: localeSchema,
    version: z.number().int().positive(), // monotonic per (docType, locale)
    /** Exactly one current row per (docType, locale) — partial-unique in DB. */
    isCurrent: z.boolean(),
    bodyHtml: z.string(), // sanitized
    effectiveAt: timestamp,
    createdAt: timestamp,
});
